/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import axios from 'axios'
import moment from 'moment'
import qs from 'qs'
import { Message } from 'element-ui'
import md5 from 'js-md5'
const Base64 = require('js-base64').Base64
import router from '../router/index'
import { addKey, removeKey } from '@/utils/auth'
// -----正式服务器开发环境------
export const apis = 'https://ren.eartip.cn/api/v1.0'
const api = 'https://cert.eartip.cn/api/v1.0'
const ops_api = 'http://ops.eartip.cn:8000/api/v1.0'
const contentApi = 'https://data.eartip.cn/api/v1.0'
// -----本地开发环境------
// const apis = 'http://127.0.0.1:5000/api/v1.0'
// export const apis = 'http://192.168.0.234:5000/api/v1.0'
// export const apis = 'http://192.168.0.254:8080/api/v1.0'
// const api = 'http://192.168.1.221:5050/api/v1.0'
// const ops_api = 'http://192.168.1.221:8000/api/v1.0'
// const contentApi = 'http://192.168.0.254:5000/api/v1.0'

const timeDiff = 100 * 1000
// const timeDiff = 100
const delay = parseInt(timeDiff)
const HTTP_AXIOS = axios.create({ timeout: delay })
axios.defaults.timeout = delay
const http = axios.create({})
http.interceptors.request.use(
  config => {
    // const token = ''
    if (storGet('user')) {
      if (storGet('user').tokenTime) {
        const date = new Date()
        const diff = Number(date.getTime()) - Number(storGet('user').tokenTime)
        // console.log(diff, '时间差')
        if (diff > (1 * 200)) {
          const promiseFresh = new Promise((resolve, reject) => {
            const ob = {
              // staffId: storGet('user').id
              staffId: storGet('user').userId
            }
            const tr = (new Date()).getTime().toString()
            ob._timestamp = tr.substring(0, 10)
            // console.log(typeof (new Date()).getTime())
            var newData = {}
            Object.keys(ob).sort().map(key => {
              newData[key] = ob[key]
            })
            const arr = []
            for (const key in newData) {
              arr.push(key.toString() + '=' + newData[key].toString())
            }
            // console.log(arr.join('&'))
            newData.sign = md5(arr.join('&')).toUpperCase()
            const str = {
              k: Base64.encode(JSON.stringify(newData))
            }
            axios.post(contentApi + '/staff/getToken', qs.stringify(str)).then(res => {
              let d = Base64.decode(res.data.d).replace(/'/g, '"')
              d = JSON.parse(d)
              // console.log(d)
              const obj = storGet('user')
              obj.token = d.data.token
              obj.tokenTime = (new Date()).getTime()
              // console.log((new Date()).getTime(), '缓存时间')
              storSet('user', obj)
              config.headers.common['token'] = storGet('user').token
              resolve(config)
            }).catch(err => {
              console.log(err)
              Message.warning('验证失效，请刷新页面重新获取！')
              // router.push('/login')
            })
          })
          return promiseFresh
          // console.log('超过10s')
          // post({
          //   url: '/staff/getToken',
          //   data: {
          //     staffId: storGet('user').id
          //   },
          //   callback(res) {
          //     const obj = storGet('user')
          //     obj.token = res.data.data.token
          //     obj.tokenTime = (new Date()).getTime()
          //     storSet('user', obj)
          //     config.headers.common['token'] = res.data.data.token
          //     return config
          //   }
          // })
          // config.headers.common['token'] = storGet('user').token
          // return config
        } else {
          config.headers.common['token'] = storGet('user').token
          return config
        }
      } else {
        Message.warning('验证失效，请重新登录！')
        storRemove('user')
        router.push('/login')
      }
      // token = storGet('user').token
      // config.headers.common['token'] = token
    } else {
      // console.log('无缓存')
      return config
    }
  },
  err => {
    return Promise.reject(err)
  }
)
export function contentPost(obj) {
  const ob = obj.data
  const tr = (new Date()).getTime().toString()
  ob._timestamp = tr.substring(0, 10)
  // console.log(typeof (new Date()).getTime())
  var newData = {}
  Object.keys(ob).sort().map(key => {
    newData[key] = ob[key]
  })
  const arr = []
  // console.log(newData)
  for (const key in newData) {
    arr.push(key.toString() + '=' + newData[key].toString())
  }
  // console.log(arr.join('&'))
  newData.sign = md5(arr.join('&')).toUpperCase()
  // console.log(JSON.stringify(newData))
  const params = {
    k: Base64.encode(JSON.stringify(newData))
  }
  // console.log(JSON.stringify(newData))
  http({
    method: 'post',
    url: contentApi + obj.url,
    data: qs.stringify(params)
  }).then(res => {
    let d = Base64.decode(res.data.d).replace(/null/g, '""')
    // console.log(d)
    d = eval('(' + d + ')')
    // console.log(d)
    const pd = {
      data: d
    }
    if (pd) {
      obj.callback(pd)
    }
  }).catch(error => {
    // console.log(error)
    // throw error
    obj.error(error)
    if (error.config.timeout == delay) {
      Message.error('请求超时，请检查网络')
    }
  })
}
export function post(obj) {
  axios({
    method: 'post',
    url: apis + obj.url,
    data: qs.stringify(obj.data)
  }).then(res => {
    if (res) {
      obj.callback(res)
    }
  }).catch(error => {
    console.log(error)
    if (error.config.timeout == delay) {
      obj.error('请求超时，请检查网络')
    } else {
      obj.error(error)
    }
  })
}

export const jsonPost = obj => {
  return new Promise((resolve, reject) => {
    axios.post(apis + obj.url, obj.data,
      { 'Content-Type:': 'application/json' })
      .then(res => {
        if (res.data.code !== 200) {
          reject(res.data.msg)
        } else {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
  })
}

export function myAxios_ops(obj, successCall, errorCall) {
  axios({
    method: 'post',
    url: obj.url,
    data: obj.data
    // headers: obj.headers
  }).then(res => {
    if (res.data.code != 200) {
      errorCall(res.data.msg)
    } else {
      setTimeout(() => {
        successCall(res.data)
      }, 120)
    }
  }).catch(error => {
    errorCall(error)
  })
}

export function httpAxios_ops(url, obj, successCall, errorCall) {
  const token = storGet('user').token
  const head = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'token': token
  }
  const data = qs.stringify(obj)
  const params = {
    // headers: head,
    url: ops_api + url,
    data: data
  }
  myAxios_ops(params, successCall, errorCall)
}

export function myAxios(obj, successCall, errorCall) {
  HTTP_AXIOS({
    method: 'post',
    url: obj.url,
    data: obj.data
  }).then(res => {
    if (res.data.code != 200) {
      errorCall(res.data.msg)
    } else {
      setTimeout(() => {
        successCall(res.data)
      }, 120)
    }
  }).catch(error => {
    if (error.config.timeout == delay) {
      errorCall('请求超时，请检查网络')
    } else {
      errorCall(error)
    }
  })
}

export function httpAxios(url, obj, successCall, errorCall) {
  const token = storGet('user').token
  const head = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'token': token
  }
  const data = qs.stringify(obj)
  const parms = {
    // headers: head,
    url: apis + url,
    data: data
  }
  myAxios(parms, successCall, errorCall)
}

export function CertAxios(obj, successCall, errorCall) {
  axios({
    method: 'post',
    url: obj.url,
    data: obj.data
    // headers: obj.headers
  }).then(res => {
    if (res.data.code != 200) {
      errorCall(res.data.msg)
    } else {
      setTimeout(() => {
        successCall(res.data)
      }, 120)
    }
  }).catch(error => {
    if (error.config.timeout == delay) {
      errorCall('请求超时，请检查网络')
    } else {
      errorCall(error)
    }
  })
}

export function httpCertPost(url, obj, successCall, errorCall) {
  // const token = storGet('user').token
  const head = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
    // 'token': token
  }
  const data = qs.stringify(obj)
  const parms = {
    // headers: head,
    url: api + url,
    data: data
  }
  CertAxios(parms, successCall, errorCall)
}

export function certPost(obj) {
  axios({
    method: 'post',
    url: api + obj.url,
    data: qs.stringify(obj.data)
  }).then(res => {
    if (res) {
      obj.callback(res)
    }
  }).catch(error => {
    console.log(error)
    if (error.config.timeout == delay) {
      obj.error('请求超时，请检查网络')
    } else {
      obj.error(error)
    }
  })
}

export function storSet(name, object) {
  const obj = JSON.stringify(object)
  localStorage.setItem(name, obj)
  // return localStorage.getItem(name)
}

export function storGet(name) {
  try {
    return JSON.parse(localStorage.getItem(name))
  } catch (e) {
    console.log(e)
    return ''
  }
}

export function storRemove(name) {
  localStorage.removeItem(name)
}

/**
 * @return {string}
 */
export function DayTo(date) {
  return moment(date).format('YYYY-MM-DD')
}

/**
 * @return {string}
 */
export function DateTo(date) {
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

export function Date_GMT(date) {
  return moment(date).utcOffset(0).format('YYYY-MM-DD HH:mm:ss')
}

/**
 * @return {string}
 * @param name
 */
export function urlQuery(name, url) {
  const obj = {}
  if (!url) {
    url = window.location.href
  }
  if (url.indexOf('?') !== -1) {
    const arr1 = url.split('?')
    const arr2 = arr1[1].split('&')
    for (const i in arr2) {
      const res = arr2[i].split('=')
      obj[res[0]] = res[1]
    }
    if (obj[name]) {
      return obj[name]
    } else {
      return ''
    }
  } else {
    return ''
  }
}

/**
 * @return {string, string}
 * @param str
 * @param name
 */

export function intercept(str, name) {
  const obj = {}
  const str2 = str.split('&')
  console.log(str2)
  for (const i in str2) {
    const res = str2[i].split('=')
    obj[res[0]] = res[1]
  }
  if (obj[name]) {
    return obj[name]
  } else {
    return ''
  }
}
